import React, { useState, useRef } from 'react'
import ButtonBlack from "../../../components/Buttons/ButtonBlack"
import { API_END_POINT } from '../../../utils/constant';
import axios from 'axios';
// import Input from '../../../components/Form/Input'

const CodeVerification = ({ data, setData, setPage }) => {
  const inp1 = useRef(null);
  const inp2 = useRef(null);
  const inp3 = useRef(null);
  const inp4 = useRef(null);
  const [notMatch, setNotMatch] = useState(false)
  const [code, setCode] = useState([undefined, undefined, undefined, undefined]);

  const handleChange = (index, prevRef, currentRef, nextRef) => {
      code[index] = currentRef.current.value
    //   console.log(code[index])
      if (currentRef.current.value !== '') {
          if (nextRef !== undefined) {
              nextRef.current.focus()
          } 
          else {
              const codeConfirmation = code[0] + code[1] + code[2] + code[3]
              setData({ ...data, code: codeConfirmation })

              // A commenter
            //   setOptions({ ...options, loading: false, disabled: false })
            //   setNotMatch(false)

              // A décommenter

              if (data.codeGenerated.toString() === codeConfirmation) {
                  console.log("hourra", data, data.codeGenerated.toString(), " et ", codeConfirmation)
                  setNotMatch(false)
                  setLoading(true)
                    axios.post(API_END_POINT + '/register', data)
                  .then((response)=>{
                  if(response.data)setPage(prev => prev += 1)
                  })
                  .catch((error)=>{
                  console.error("Erreur lors de l'inscription",error)
                  })
                  .finally(()=>{setLoading(false);})
                  
              } else {
                //   alert('oups')
                console.log("Oups", data, data.codeGenerated.toString(), " et ", codeConfirmation)
                  setNotMatch(true)
                  code[0] = undefined
                  code[1] = undefined
                  code[2] = undefined
                  code[3] = undefined
              }
          }
      } else if (currentRef.current.value === '') {
          if (prevRef !== undefined) {
              prevRef.current.focus()
          }
      }

  }
  const [options, setOptions] = useState({
      loading: false,
      disabled: true
  })
  const [isLoading, setisLoading] = useState(false)
  const [isOpen, setIsOpen] = useState({
      fails: false
  })
    const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)  
        await axios.post(API_END_POINT + '/register', data)
    .then((response)=>{
    if(response.data)setPage(prev => prev += 1)
    })
    .catch((error)=>{
    console.error("Erreur lors de l'inscription",error)
    })
    .finally(()=>{setLoading(false);})

      // setLoading(false);
  }



  // useEffect(() => {
  //     if (data.code !== '') {
  //         setOptions({ ...options, disabled: false })
  //     } else {
  //         setOptions({ ...options, disabled: true })
  //     }
  // }, [data])

  return (
    <div className="w-full p-6 space-y-8 sm:p-8 bg-white rounded-lg shadow mt-6 min-h-[400px]">
    <form onSubmit={(e) => handleSubmit(e)} className="verification-form">
        <p className="verification-text">
            Nous avons envoyé un code de vérification à votre adresse e-mail 
            <span className="verification-email">{data?.email}</span>
        </p>
        <div className="verification-input-grid">
            <input type="text" ref={inp1} value={code[0]} onChange={(e) => handleChange(0, undefined, inp1, inp2)} maxLength={1} className="verification-input" />
            <input type="text" ref={inp2} value={code[1]} onChange={(e) => handleChange(1, inp1, inp2, inp3)} maxLength={1} className="verification-input" />
            <input type="text" ref={inp3} value={code[2]} onChange={(e) => handleChange(2, inp2, inp3, inp4)} maxLength={1} className="verification-input" />
            <input type="text" ref={inp4} value={code[3]} onChange={(e) => handleChange(3, inp3, inp4, undefined)} maxLength={1} className="verification-input" />
        </div>

        {notMatch && (
            <div className="verification-error-container">
                <span className="verification-error-message">
                    <span className="verification-error-close"></span>
                    <span className="verification-error-text">
                        <p>
                            Réessayer. Nous avons envoyé un autre code de vérification à votre adresse e-mail.
                        </p>
                    </span>
                </span>
            </div>
        )}

        <ButtonBlack radius='sm' onClick={(e) => handleSubmit(e)} isLoading={isLoading}>
            Suivant
        </ButtonBlack>
    </form>
</div>

  )
}

export default CodeVerification